var spoiler_default = {
  "fontElementMap": "sNCO5",
  "hideText": "P9fvQ",
  "onHoverText": "e0isT",
  "hideBlock": "lc3-F",
  "smallBlur": "nNkop",
  "mediumBlur": "rx06Q",
  "largeBlur": "PHNPP",
  "hideBlock_gallery": "y0UID",
  "overlay": "_8P-sG",
  "overlay_gallery": "-eMaU",
  "revealSpoilerBtn": "dv6DS",
  "isMobile": "_6vAsd",
  "onHoverBtn": "EApLL",
  "spoilerWrapper": "bIFz8",
  "spoilerDescription": "lKIDM",
  "spoilerContainer": "HB2d-",
  "spoilerContainer_Gallery": "_0ThzE"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
